import React  from "react";
import TruveyBlackLogo from '../Asset/Images/XSO-Black.png';
import TruveyGreenLogo from '../Asset/Images/XSO-Green.png';
import { Link } from "react-router-dom";
const UpperFooter = () => {
    // const [IsLogged, SetIsLogged] = useState(false);
    // useEffect(() => {
    //     const token = localStorage.getItem("JWTToken");
    //     if (token) {
    //         SetIsLogged(true);
    //     }
    // }, [])
    return (<>
        {/* {
            !IsLogged ? (<>
            </>) : (<>
            </>)
        } */}
        <div className="mt-5 border-bottom">
            <div className="container">
                <div className="row justify-center">
                    <div className="col-md-4">
                        <div className="Img-set mb-2">
                            <img src={TruveyGreenLogo} alt=".../" className="w-50" />
                        </div>
                        <p>info@expresscleanslate.com</p>
                        <div className="social-icons">
                            <a href="#" className="p-2 HoverFacebook"><i className="fab fa-facebook"></i></a>
                            <a href="#" className="p-2 HoverTwitter"><i className="fab fa-twitter"></i></a>
                            <a href="#" className="p-2 HoverInstagram"><i className="fab fa-instagram"></i></a>
                            <a href="#" className="p-2 HoverLinkedin"><i className="fab fa-linkedin"></i></a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h5>Quick Links</h5>
                        <ul className="list-unstyled ps-3 mb-4">
                            <li className="mb-2"><Link to="/Home" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i>  Home</Link></li>
                            <li className="mb-2"><Link to="/Login" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i>  SignIn</Link></li>
                            <li className="mb-2"><Link to="/SignUp" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i>  SignUp</Link></li>
                            <li className="mb-2"><Link to="/PrivacyPolicy" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i>  Privacy Policy</Link></li>
                            <li className="mb-2"><Link to="/TermsAndCondtion" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i>  Terms And Condition</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <h5>Other Services  And Products</h5>
                        <ul className="list-unstyled ps-3 mb-4">
                            <li className="mb-2"><a href="https://www.opt4solution.site/"  target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> Recruitment & Staffing</a></li>
                            <li className="mb-2"><a href="https://www.vrsamadhantech.com/" target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> Tech Solutions</a></li>
                            <li className="mb-2"><a href="https://www.opt4solution.site/"  target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> HR & Payroll</a></li>
                            <li className="mb-2"><a href="https://opt4crm.com/" target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> CRM Portal</a></li>
                            <li className="mb-2"><a href="https://vrsjobs.com/" target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> Job Portal</a></li>
                            <li className="mb-2"><a href="https://www.opt4solution.site/" target="_blank" className="text-dark fs-14 HoverTruvey"><i class="fa-solid fa-arrow-right fs-12"></i> Other Solutions</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default UpperFooter;